import React, { useMemo, useState } from 'react';
import defaultAvatar from '@src/assets/avatars/002.png';
import classNames from 'classnames';
import styles from './index.module.less';

export interface AvatarProps {
  src?: string;
  size?: number | string;
  fallback?: React.ReactNode;
  className?: string;
}

export const Avatar: React.FC<AvatarProps> = ({
  src,
  size = 32,
  fallback,
  className,
}) => {
  const [isImgError, setIsImgError] = useState(false);
  const hasValidSrc = !!src && !isImgError;

  const avatarSizeStyle = useMemo(() => {
    const value = typeof size === 'number' ? `${size}px` : size;
    return {
      width: value,
      height: value,
    };
  }, [size]);

  return (
    <div
      className={classNames(styles.avatar, className)}
      style={avatarSizeStyle}
    >
      {hasValidSrc ? (
        <img
          src={src}
          alt="avatar"
          loading="lazy"
          decoding="async"
          className={styles.avatarImage}
          onError={() => setIsImgError(true)}
        />
      ) : (
        <div className={styles.avatarFallback}>
          {fallback ?? (
            <img
              data-origin-src={src}
              src={defaultAvatar}
              alt="default-avatar"
              className={styles.avatarImage}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default Avatar;
